
/*
enums
creates an enum object from a list of strings

input: [
  'ENUM_ONE',
  'ENUM_TWO,
  'ENUM_THREE'
]

output: {
  ENUM_ONE: 'ENUM_ONE',
  ENUM_TWO: 'ENUM_TWO,
  ENUM_THREE: 'ENUM_THREE'
}

*/

export default function enums(list) {
  return list.reduce((memo, key) => {
    // eslint-disable-next-line no-param-reassign
    memo[key] = key;
    return memo;
  }, {});
}
